<template>
  <div class="search-criteria-container">
    <div class="input-content">
      <div class="row">
        <div class="company-input" @click.stop>
          <el-input
            @focus="onCompanyInputFocus"
            @input="searchTermsRecommend"
            clearable
            v-model="companyInput"
            placeholder="代码/简称"
            @keypress.enter.native="onSearch"
          />
          <div v-if="showMatchedItems && matchedItems.length" class="company-recommended">
            <div
              @click.stop="onSelectCompany(item.fullname)"
              class="company-name"
              v-for="(item, index) in matchedItems"
              :key="index"
            >{{item.fullname}}</div>
          </div>
        </div>
        <span class="company-input-title input-title">公司名称</span>
        <!-- <div class="title-button" @click="onShowExcludeTitleInput">
          <img class="arrow-img" v-if="showExcludeTitleInput" src="../../assets/img/up-arrow.svg"/>
          <img class="arrow-img" v-else src="../../assets/img/down-arrow.svg"/>
        </div>-->
        <el-date-picker
          v-model="time"
          type="daterange"
          align="right"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="onTimeChange(time)"
        ></el-date-picker>
        <div class="search-btn" @click="onSearch">搜索</div>
      </div>
      <div class="row">
        <el-input
          clearable
          class="title-input"
          v-model="titleInput"
          placeholder="匹配全部搜索词"
          @keypress.enter.native="onSearch"
        ></el-input>
        <span class="title-input-title input-title">研报标题</span>
        <div class="title-button" @click="onShowExcludeTitleInput">
          <img class="arrow-img" v-if="showExcludeTitleInput" src="../../assets/img/up-arrow.svg" />
          <img class="arrow-img" v-else src="../../assets/img/down-arrow.svg" />
        </div>
      </div>
      <div v-if="showExcludeTitleInput">
        <el-input
          clearable
          @keypress.enter.native="onSearch"
          class="exclude-title-input"
          v-model="excludeTitleInput"
          placeholder="不匹配此搜索内容"
        ></el-input>
        <span class="exclude-title-input-title input-title">研报标题</span>
      </div>
      <div class="row">
        <el-input
          clearable
          @keypress.enter.native="onSearch"
          class="text-input"
          v-model="textInput"
          placeholder="例子:中国gdp/新能源汽车销售"
        ></el-input>
        <span
          class="text-input-title input-title"
          :class="{'text-input-title1': !showExcludeTitleInput}"
        >研报正文</span>
        <div class="text-button" @click="onShowExcludeTextInput">
          <img v-if="showExcludeTextInput" class="arrow-img" src="../../assets/img/up-arrow.svg" />
          <img v-else class="arrow-img" src="../../assets/img/down-arrow.svg" />
        </div>
      </div>
      <div v-if="showExcludeTextInput">
        <el-input
          clearable
          @keypress.enter.native="onSearch"
          class="exclude-text-input"
          v-model="excludeTextInput"
          placeholder="不匹配此搜索内容"
        ></el-input>
        <span
          class="exclude-text-input-title input-title"
          :class="{'exclude-text-input-title1': !showExcludeTitleInput}"
        >研报正文</span>
      </div>
    </div>
    <div class="common-filters">
      <div class="common-filters-box row">
        <div class="common-filters-title">常用筛选</div>
        <div
          v-for="(v,index) in commonFilter"
          :key="index"
          :class="[category.length?'common-filter-item disable-checked':'common-filter-item']"
        >
          <el-checkbox class="checkbox" v-model="v.checked" @change="changeToOptional">
            <span :class="[category.length?'disable-checked':'']">{{v.title}}</span>
          </el-checkbox>
        </div>
      </div>
    </div>
    <div class="row filter-module">
      <div class="row filter-btn" @click="onOpenFilterDialog('researchInstitutions')">研究机构</div>
      <div
        :class="[this.commonFilter.some(v=>v.checked)?'row filter-btn disable-btn':'row filter-btn']"
        @click="onOpenFilterDialog('researchReportCategory')"
      >研报类别</div>
      <div class="row filter-btn" @click="onOpenFilterDialog('industryCategories')">行业类别</div>
      <div class="row filter-btn" @click="onOpenFilterDialog('pageNumberScreening')">页码筛选</div>
    </div>
    <div class="row filter-content" v-if="!dialogVisible">
      <div class="row filter-content-btn" v-for="(item, index) in filterConditions" :key="index">
        {{item}}
        <div @click="onReduceFilterConditions(item)" class="filter-content-btn-close"></div>
      </div>
      <div v-if="filterConditions.length" class="delete-btn" @click="deleteAllFilterConditions"></div>
    </div>
    <el-dialog title class="dialog" :visible.sync="dialogVisible" width="638px" :show-close="false">
      <div class="row dialog-tab">
        <div
          class="tab-btn"
          :class="{'active': selectedOptionTab === 'researchInstitutions'}"
          @click="onFilterDialogTab('researchInstitutions')"
        >研究机构</div>
        <div
          class="tab-btn"
          :class="[ selectedOptionTab === 'researchReportCategory'?'active':'',this.commonFilter.some(v=>v.checked)?'is-disable':'']"
          @click="onFilterDialogTab('researchReportCategory')"
        >研报类别</div>
        <div
          class="tab-btn"
          :class="{'active': selectedOptionTab === 'industryCategories'}"
          @click="onFilterDialogTab('industryCategories')"
        >行业类别</div>
        <div
          class="tab-btn"
          :class="{'active': selectedOptionTab === 'pageNumberScreening'}"
          @click="onFilterDialogTab('pageNumberScreening')"
        >页码筛选</div>
      </div>
      <div class="row filter-content">
        <div class="row filter-content-btn" v-for="(item, index) in filterConditions" :key="index">
          {{item}}
          <div @click="onReduceDialogFilterConditions(item)" class="filter-content-btn-close"></div>
        </div>
      </div>
      <div class="dialog-select">
        <div v-if="selectedOptionTab === 'researchInstitutions'">
          <div>
            <el-input
              class="institution-input"
              v-model="institutionInput"
              @input="institutionInputChange"
              placeholder="搜索"
            ></el-input>
          </div>
          <div class="row institution-dialog-select-content">
            <div
              @click="onAddFilterConditions(item, 'institutionContent')"
              :class="{'active': filterConditions.indexOf(item) > -1}"
              class="dialog-select-btn"
              v-for="(item, index) in institutionContent"
              :key="index"
            >{{item}}</div>
          </div>
        </div>
        <div
          class="row dialog-select-content"
          v-if="selectedOptionTab === 'researchReportCategory'"
        >
          <div
            @click="onAddFilterConditions(item, 'category')"
            :class="{'active': filterConditions.indexOf(item) > -1}"
            class="dialog-select-btn"
            v-for="(item, index) in categoryContent"
            :key="index"
          >{{item}}</div>
        </div>
        <div class="row dialog-select-content" v-if="selectedOptionTab === 'industryCategories'">
          <div
            @click="onAddFilterConditions(item, 'industry')"
            :class="{'active': filterConditions.indexOf(item) > -1}"
            class="dialog-select-btn"
            v-for="(item, index) in industryContent"
            :key="index"
          >{{item}}</div>
        </div>
        <div class="dialog-select-content" v-if="selectedOptionTab === 'pageNumberScreening'">
          <el-radio-group v-model="pdfSize" @change="changePdfSize">
            <el-radio :label="'1-5页'">1-5页</el-radio>
            <el-radio :label="'6-20页'">6-20页</el-radio>
            <el-radio :label="'20页以上'">20页以上</el-radio>
          </el-radio-group>
          <!-- <div @click="onAddFilterConditions(item)" class="dialog-select-btn" v-for="(item, index) in pageFilter" :key="index">{{item}}</div> -->
        </div>
      </div>
      <div class="dialog-footer">
        <div class="footer">
          <div class="footer-btn">
            <el-button class="cancel-btn" @click="cancelBtnClick">取消</el-button>
            <el-button class="confirm-btn" @click="confirmBtnClick">提交</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="filter-conflicts-dialog"
      title="筛选冲突"
      :visible.sync="filterConflictsDialogVisible"
      width="400px"
    >
      <div class="dialog-content">常用筛选与研报类别筛选为互斥关系，不能同时使用。继续将去掉互斥的选项。</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="onFilterConflictsDialogCancel">取消</el-button>
        <el-button class="btn confirm-btn" type="primary" @click="onFilterConflictsDialogConfirm">继续</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="filter-conflicts-dialog"
      title="筛选冲突"
      :visible.sync="filterConflictsDialogVisibleB"
      width="400px"
    >
      <div class="dialog-content">常用筛选与研报类别筛选为互斥关系，不能同时使用。继续将去掉互斥的选项。</div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn cancel-btn" @click="onFilterConflictsDialogCancelB">取消</el-button>
        <el-button
          class="btn confirm-btn"
          type="primary"
          @click="onFilterConflictsDialogConfirmB"
        >继续</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import filterHelper from '@/helpers/filterHelper';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      showMatchedItems: false,
      matchedItems: [],
      companyInput: '',
      originalFilterConditions: [],
      originalInstitution: [],
      originalCategory: [],
      originalIndustry: [],
      originalPdfSize: '',
      timer: {},
      companyInputTimer: null,
      pdfSize: '',
      institutionInput: '',
      filterConditions: [],
      pageFilter: ['1-5页', '6-20页', '20页以上'],
      commonFilter: [
        { checked: false, title: '行业定期' },
        { checked: false, title: '行业深度' },
        { checked: false, title: '行业点评' },
        { checked: false, title: '公司深度' },
        { checked: false, title: '公司点评' },
        { checked: false, title: '调研纪要' },
        { checked: false, title: '新股报告' }
      ],
      institution: [],
      industry: [],
      category: [],
      institutionContent: [],
      industryContent: [],
      categoryContent: [],
      date: {},
      showExcludeTitleInput: false,
      showExcludeTextInput: false,
      titleInput: '',
      excludeTitleInput: '',
      textInput: '',
      excludeTextInput: '',
      selectedOptionTab: 'researchInstitutions',
      dialogVisible: false,
      filterConflictsDialogVisible: false,
      filterConflictsDialogVisibleB: false,
      searchOrNot: false,
      time: [],
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > new Date();
        },
        shortcuts: [
          {
            text: '近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近半年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '近一年',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  props: {
    questionJson: {
      type: Object
    }
  },
  watch: {
    companyInput(val) {
      if (!val) {
        this.getSearchTermsRecommend();
      }
    },
    questionJson(val) {
      this.filterConditions = [];
      this.filterConditions = this.filterConditions.concat(val.institution);
      this.filterConditions = this.filterConditions.concat(val.category);
      this.filterConditions = this.filterConditions.concat(val.industry);
      if (val.genre) {
        this.commonFilter = this.commonFilter.map(v => {
          if (val.genre.includes(v.title)) v.checked = true;
          else v.checked = false;
          return v;
        });
      } else {
        this.commonFilter = this.commonFilter.map(v => {
          v.checked = false;
          return v;
        });
      }
      if (val.pdfSize.min === 0) {
        this.pdfSize = '';
      } else if (val.pdfSize.min === 1) {
        this.pdfSize = '1-5页';
        this.filterConditions.push('1-5页');
      } else if (val.pdfSize.min === 6) {
        this.pdfSize = '6-20页';
        this.filterConditions.push('6-20页');
      } else if (val.pdfSize.min === 20) {
        this.pdfSize = '20页以上';
        this.filterConditions.push('20页以上');
      }
      this.institution = val.institution;
      this.category = val.category;
      this.industry = val.industry;
      this.$emit('submitFilter', {
        filterConditionsData: this.filterConditions,
        institutionData: val.institution,
        categoryData: val.category,
        industryData: val.industry,
        pdfSizeData: this.pdfSize
      });
      this.companyInput = val.company;
      this.titleInput = val.title.include;
      this.excludeTitleInput = val.title.exclude;
      this.textInput = val.text.include;
      this.excludeTextInput = val.text.exclude;
      this.time = [];
      if (val.date.start && val.date.end) {
        this.time.push(val.date.start);
        this.time.push(val.date.end);
      }
      this.date = {
        start: val.date.start,
        end: val.date.end
      };
      if (val.isPrecision) {
        this.showExcludeTextInput = val.isPrecision.isPrecision;
      }
      if (val.title.exclude) {
        this.showExcludeTitleInput = true;
      }
      if (val.text.exclude) {
        this.showExcludeTextInput = true;
      }
      this.onSearch();
    }
  },
  methods: {
    changeToOptional() {
      if (this.category.length) {
        this.filterConflictsDialogVisibleB = true;
      } else {
        this.$emit('submitFilter', {
          filterConditionsData: this.filterConditions,
          institutionData: this.institution,
          categoryData: this.category,
          industryData: this.industry,
          pdfSizeData: this.pdfSize
        });
        this.onSearch();
      }
    },
    onFilterConflictsDialogCancel() {
      this.filterConflictsDialogVisible = false;
    },
    onFilterConflictsDialogConfirm() {
      this.filterConflictsDialogVisible = false;
      this.commonFilter = this.commonFilter.map(v => {
        v.checked = false;
        return v;
      });
      this.searchOrNot = true;
      setTimeout(() => {
        this.onOpenFilterDialog('researchReportCategory');
      }, 500);
    },
    onFilterConflictsDialogCancelB() {
      this.filterConflictsDialogVisibleB = false;
      this.commonFilter = this.commonFilter.map(v => {
        v.checked = false;
        return v;
      });
    },
    onFilterConflictsDialogConfirmB() {
      this.filterConflictsDialogVisibleB = false;
      this.filterConditions = this.filterConditions.filter(
        v => !this.category.includes(v)
      );
      this.category = [];
      this.$emit('submitFilter', {
        filterConditionsData: this.filterConditions,
        institutionData: this.institution,
        categoryData: this.category,
        industryData: this.industry,
        pdfSizeData: this.pdfSize
      });
      this.onSearch();
    },
    onCompanyInputFocus() {
      this.showMatchedItems = true;
      if (!this.companyInput) {
        this.getSearchTermsRecommend();
      }
    },
    onCompanyInputBlur() {
      this.showMatchedItems = false;
    },
    searchTermsRecommend() {
      this.showMatchedItems = false;
      if (this.companyInputTimer) {
        clearTimeout(this.companyInputTimer);
      }
      this.companyInputTimer = setTimeout(() => {
        if (this.companyInput) {
          this.getSearchTermsRecommend();
        }
      }, 300);
    },
    async getSearchTermsRecommend() {
      const oldSearchText = this.companyInput;
      const res = await QuestionQuery.dynamicMatch(this.companyInput);
      if (this.companyInput === oldSearchText) {
        this.matchedItems = res.matchedItems;
        this.showMatchedItems = true;
      }
    },
    onSelectCompany(res) {
      this.companyInput = res;
      this.showMatchedItems = false;
    },
    institutionInputChange() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.institutionContent = filterHelper.institution;
        this.institutionContent = filterHelper.institution.filter(item => {
          if (item.indexOf(this.institutionInput) > -1) {
            return true;
          }
          return null;
        });
      }, 600);
    },
    deleteAllFilterConditions() {
      this.filterConditions = [];
      this.institution = [];
      this.category = [];
      this.industry = [];
      this.pdfSize = '';
      this.$emit('submitFilter', {
        filterConditionsData: this.filterConditions,
        institutionData: this.institution,
        categoryData: this.category,
        industryData: this.industry,
        pdfSizeData: this.pdfSize
      });
      this.onSearch();
    },
    changePdfSize(res) {
      if (this.filterConditions.indexOf('1-5页') > -1) {
        this.filterConditions.splice(this.filterConditions.indexOf('1-5页'), 1);
      } else if (this.filterConditions.indexOf('6-20页') > -1) {
        this.filterConditions.splice(
          this.filterConditions.indexOf('6-20页'),
          1
        );
      } else if (this.filterConditions.indexOf('20页以上') > -1) {
        this.filterConditions.splice(
          this.filterConditions.indexOf('20页以上'),
          1
        );
      }
      this.filterConditions.push(res);
    },
    onAddFilterConditions(res, type) {
      if (this.filterConditions.indexOf(res) === -1) {
        this.filterConditions.push(res);
        if (type === 'institutionContent') {
          this.institution.push(res);
        } else if (type === 'category') {
          this.category.push(res);
        } else if (type === 'industry') {
          this.industry.push(res);
        }
      }
    },
    onReduceDialogFilterConditions(res) {
      this.filterConditions.splice(this.filterConditions.indexOf(res), 1);
      if (res === this.pdfSize) {
        this.pdfSize = '';
      }
      if (this.institution.indexOf(res) > -1) {
        this.institution.splice(this.institution.indexOf(res), 1);
      } else if (this.category.indexOf(res) > -1) {
        this.category.splice(this.category.indexOf(res), 1);
      } else if (this.industry.indexOf(res) > -1) {
        this.industry.splice(this.industry.indexOf(res), 1);
      }
    },
    onReduceFilterConditions(res) {
      this.filterConditions.splice(this.filterConditions.indexOf(res), 1);
      if (res === this.pdfSize) {
        this.pdfSize = '';
      }
      if (this.institution.indexOf(res) > -1) {
        this.institution.splice(this.institution.indexOf(res), 1);
      } else if (this.category.indexOf(res) > -1) {
        this.category.splice(this.category.indexOf(res), 1);
      } else if (this.industry.indexOf(res) > -1) {
        this.industry.splice(this.industry.indexOf(res), 1);
      }
      this.$emit('submitFilter', {
        filterConditionsData: this.filterConditions,
        institutionData: this.institution,
        categoryData: this.category,
        industryData: this.industry,
        pdfSizeData: this.pdfSize
      });
      this.onSearch();
    },
    onOpenFilterDialog(tabName) {
      if (
        tabName === 'researchReportCategory' && this.commonFilter.some(v => v.checked)
      ) {
        this.filterConflictsDialogVisible = true;
      } else {
        this.originalFilterConditions = JSON.parse(
          JSON.stringify(this.filterConditions)
        );
        this.originalInstitution = JSON.parse(JSON.stringify(this.institution));
        this.originalCategory = JSON.parse(JSON.stringify(this.category));
        this.originalIndustry = JSON.parse(JSON.stringify(this.industry));
        this.originalPdfSize = this.pdfSize;
        this.selectedOptionTab = tabName;
        this.dialogVisible = true;
      }
    },
    onFilterDialogTab(tabName) {
      if (
        tabName !== 'researchReportCategory' || !this.commonFilter.filter(v => v.checked).length
      ) {
        this.selectedOptionTab = tabName;
      } else {
        this.filterConflictsDialogVisible = true;
      }
    },
    cancelBtnClick() {
      this.filterConditions = JSON.parse(
        JSON.stringify(this.originalFilterConditions)
      );
      this.institution = JSON.parse(JSON.stringify(this.originalInstitution));
      this.category = JSON.parse(JSON.stringify(this.originalCategory));
      this.industry = JSON.parse(JSON.stringify(this.originalIndustry));
      this.pdfSize = this.originalPdfSize;
      this.dialogVisible = false;
      if (this.searchOrNot) {
        this.$emit('submitFilter', {
          filterConditionsData: this.filterConditions,
          institutionData: this.institution,
          categoryData: this.category,
          industryData: this.industry,
          pdfSizeData: this.pdfSize
        });
        this.onSearch();
        this.searchOrNot = false;
      }
    },
    confirmBtnClick() {
      this.dialogVisible = false;
      this.$emit('submitFilter', {
        filterConditionsData: this.filterConditions,
        institutionData: this.institution,
        categoryData: this.category,
        industryData: this.industry,
        pdfSizeData: this.pdfSize
      });
      this.onSearch();
    },
    onShowExcludeTitleInput() {
      this.showExcludeTitleInput = !this.showExcludeTitleInput;
    },
    onShowExcludeTextInput() {
      this.showExcludeTextInput = !this.showExcludeTextInput;
    },
    onSearch() {
      this.showMatchedItems = false;
      if (!this.showExcludeTextInput) {
        this.excludeTextInput = '';
      }
      const genre = this.commonFilter.filter(v => v.checked).map(v => v.title);
      const params = {
        company: this.companyInput,
        title: {
          include: this.titleInput,
          exclude: this.excludeTitleInput
        },
        text: {
          include: this.textInput,
          exclude: this.excludeTextInput
        },
        date: this.date,
        genre,
        isPrecision: this.showExcludeTextInput
      };
      this.$emit('search', params);
    },
    onTimeChange(res) {
      if (!res) {
        this.date = {};
      } else {
        this.date = {
          start: res[0],
          end: res[1]
        };
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.onCompanyInputBlur);
    this.industryContent = filterHelper.industry;
    this.institutionContent = filterHelper.institution;
    this.categoryContent = filterHelper.category;
    eventBus.$on('userLogout', () => {
      this.companyInput = '';
      this.titleInput = '';
      this.excludeTitleInput = '';
      this.textInput = '';
      this.excludeTextInput = '';
      this.time = [];
      this.showExcludeTextInput = false;
      this.deleteAllFilterConditions();
    });
    eventBus.$on('userLoginBus', () => {
      this.companyInput = '';
      this.titleInput = '';
      this.excludeTitleInput = '';
      this.textInput = '';
      this.excludeTextInput = '';
      this.time = [];
      this.showExcludeTextInput = false;
      this.deleteAllFilterConditions();
    });
  },
  beforeDestroy() {
    // un-register events
    if (this.showMatchedItems) {
      this.onCompanyInputBlur();
    }
    document.removeEventListener('click', this.onCompanyInputBlur);
  }
};
</script>

<style lang="scss" scoped>
.search-criteria-container {
  position: relative;
  padding: 32px 32px 22px;
  min-height: 192px;
  background-color: #ffffff;
  .input-content {
    padding-bottom: 10px;
    box-shadow: inset 0px -1px 0px 0px #f2f3f7;
    .company-input {
      position: relative;
      margin-right: 10px;
      width: 388px;
      .company-recommended {
        padding: 6px 0;
        position: absolute;
        width: 388px;
        background-color: #ffffff;
        box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
        border-radius: 4px;
        border: solid 1px #f7f7fa;
        z-index: 2;
        .company-name {
          width: 100%;
          height: 40px;
          line-height: 40px;
          padding-left: 48px;
          color: #171f46;
          cursor: pointer;
          &:hover {
            background-color: rgba(0, 11, 92, 0.03);
          }
        }
      }
    }
    .title-input {
      margin-top: 10px;
      width: 700px;
    }
    .input-title {
      position: absolute;
      left: 48px;
      color: #747990;
      font-size: 12px;
    }
    .company-input-title {
      top: 40px;
    }
    .title-input-title {
      top: 82px;
      // top: 40px;
    }
    .title-button {
      width: 48px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      margin-left: 2px;
      margin-top: 10px;
      background-color: rgba(0, 11, 92, 0.03);
      border-radius: 2px;
      cursor: pointer;
      &:hover {
        background-image: linear-gradient(
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0.1)
          ),
          linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:active {
        background-color: #e6eeff;
      }
      .arrow-img {
        margin-top: -2px;
        vertical-align: middle;
      }
    }
    .search-btn {
      margin-left: 10px;
      width: 88px;
      height: 32px;
      line-height: 32px;
      border-radius: 2px;
      color: #ffffff;
      font-size: 14px;
      font-weight: 500;
      text-align: center;
      background-color: #0055ff;
      cursor: pointer;
      &:hover {
        color: #ffffff;
        background-image: linear-gradient(
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0.1)
          ),
          linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
      &:focus {
        color: #ffffff;
        background-image: linear-gradient(
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0.1)
          ),
          linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
      &:active {
        color: #ffffff;
        background-image: linear-gradient(
            rgba(0, 0, 0, 0.2),
            rgba(0, 0, 0, 0.2)
          ),
          linear-gradient(#0055ff, #0055ff);
        background-blend-mode: normal, normal;
      }
    }
    .exclude-title-input {
      margin-top: 10px;
      width: 700px;
    }
    .exclude-title-input-title {
      // top: 82px;
      top: 124px;
    }
    .text-input {
      width: 700px;
      margin-top: 10px;
    }
    .text-input-title {
      // top: 124px;
      top: 166px;
    }
    .text-input-title1 {
      // top: 82px;
      top: 124px;
    }
    .text-button {
      margin-top: 10px;
      width: 48px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      margin-left: 2px;
      background-color: rgba(0, 11, 92, 0.03);
      border-radius: 2px;
      cursor: pointer;
      &:hover {
        background-image: linear-gradient(
            rgba(0, 0, 0, 0.1),
            rgba(0, 0, 0, 0.1)
          ),
          linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
        background-blend-mode: normal, normal;
      }
      &:active {
        background-color: #e6eeff;
      }
      .arrow-img {
        margin-top: -2px;
        vertical-align: middle;
      }
    }
    .exclude-text-input {
      width: 700px;
      margin-top: 10px;
    }
    .exclude-text-input-title {
      // top: 166px;
      top: 208px;
    }
    .exclude-text-input-title1 {
      // top: 124px;
      top: 166px;
    }
  }
  .common-filters {
    height: 42px;
    box-shadow: inset 0px -1px 0px 0px #f2f3f7;
    .common-filters-box {
      width: 600px;
      .common-filters-title {
        width: 56px;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 16px;
        letter-spacing: 0px;
        color: #747990;
        padding: 13px 0;
        flex-shrink: 0;
      }
      .common-filter-item {
        padding: 10px 0;
        margin-left: 17px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 22px;
        letter-spacing: 0px;
        color: #747990;
        /deep/ .el-checkbox__label {
          padding-left: 6px;
        }
        /deep/ .el-checkbox__label {
          span {
            color: #747990;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 22px;
            letter-spacing: 0px;
          }
          .disable-checked {
            color: #d1d2da;
          }
        }
      }
    }
  }
  .filter-module {
    padding: 10px 0;
    .filter-btn {
      height: 32px;
      padding: 5px 16px;
      margin-right: 10px;
      border-radius: 2px;
      border: 1px solid #e5e6ee;
      color: #747990;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        border: 1px solid #171f46;
        color: #171f46;
        background-color: #ffffff;
      }
      &:active {
        border: 1px solid #171f46;
        color: #171f46;
        background-color: #f2f3f7;
      }
      &:after {
        content: "";
        margin-left: 4px;
        margin-top: 2px;
        width: 16px;
        height: 16px;
        background: url("../../assets/img/add.svg") no-repeat;
        background-size: cover;
      }
    }
    .disable-btn {
      color: #d1d2da;
      &:hover {
        border: 1px solid #e5e6ee;
        color: #d1d2da;
        background-color: #ffffff;
      }
      &:after {
        content: "";
        margin-left: 4px;
        margin-top: 2px;
        width: 16px;
        height: 16px;
        background: url("../../assets/img/add-grey.svg") no-repeat;
      }
    }
  }
}
.filter-content {
  width: 100%;
  flex-wrap: wrap;
  min-height: 0;
  .filter-content-btn {
    padding: 8px;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 2px;
    border: dashed 1px #cccede;
    color: #747990;
    font-size: 12px;
    .filter-content-btn-close {
      margin-left: 8px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      background: url("../../assets/img/close.svg") no-repeat;
      background-size: cover;
      cursor: pointer;
      &:hover {
        background: url("../../assets/img/close-hover.svg") no-repeat;
      }
    }
  }
  .delete-btn {
    width: 48px;
    height: 32px;
    padding: 8px 16px;
    background-color: rgba(0, 11, 92, 0.03);
    border-radius: 2px;
    cursor: pointer;
    &:hover {
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
        linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      background-color: #e6eeff;
    }
    &:before {
      content: "";
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url("../../assets/img/clear-search-criteria.svg") no-repeat;
      background-size: cover;
    }
  }
}
/deep/.dialog {
  .dialog-tab {
    position: relative;
    width: 100%;
    height: 48px;
    padding: 14px 0 0 16px;
    font-size: 14px;
    color: #747990;
    box-shadow: inset 0px -1px 0px 0px#f2f3f7;
    .tab-btn {
      margin-right: 40px;
      cursor: pointer;
    }
    .active {
      position: relative;
      color: #171f46;
    }
    .is-disable {
      color: #d1d2da;
    }
    .active::after {
      content: "";
      position: absolute;
      bottom: 1px;
      left: 3px;
      width: 50px;
      height: 2px;
      background-color: #171f46;
    }
  }
  .filter-content {
    padding: 10px 16px 0;
    width: 100%;
    flex-wrap: wrap;
    min-height: 52px;
    box-shadow: inset 0px -1px 0px 0px#f2f3f7;
    .filter-content-btn {
      padding: 8px;
      margin-right: 10px;
      margin-bottom: 10px;
      border-radius: 2px;
      border: dashed 1px #cccede;
      color: #747990;
      font-size: 12px;
      .filter-content-btn-close {
        margin-left: 8px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        background: url("../../assets/img/close.svg") no-repeat;
        background-size: cover;
        cursor: pointer;
        &:hover {
          background: url("../../assets/img/close-hover.svg") no-repeat;
        }
      }
    }
  }
  .dialog-select {
    padding: 16px 16px 20px;
    width: 100%;
    height: 288px;
    box-shadow: inset 0px -1px 0px 0px#f2f3f7;
    .institution-input {
      width: 346px;
      padding-bottom: 10px;
    }
    /deep/.el-input .el-input__inner {
      padding-left: 16px;
    }
    .institution-dialog-select-content {
      height: 230px;
      overflow-y: auto;
      flex-wrap: wrap;
      .dialog-select-btn {
        height: 32px;
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 8px;
        border-radius: 2px;
        border: solid 1px #e5e6ee;
        font-size: 12px;
        color: #747990;
        cursor: pointer;
        &:hover {
          border: 1px solid #171f46;
          background-color: #ffffff;
        }
        &:active {
          border: 1px solid #171f46;
          background-color: #f2f3f7;
        }
      }
      .active {
        border: solid 1px #0055ff;
        &:hover {
          border: solid 1px #0055ff;
        }
        &:active {
          border: 1px solid #0055ff;
          background-color: #ffffff;
        }
      }
    }
    .dialog-select-content {
      flex-wrap: wrap;
      .dialog-select-btn {
        margin-right: 10px;
        margin-bottom: 10px;
        padding: 8px;
        border-radius: 2px;
        border: solid 1px #e5e6ee;
        font-size: 12px;
        color: #747990;
        cursor: pointer;
        &:hover {
          border: 1px solid #171f46;
          background-color: #ffffff;
        }
        &:active {
          border: 1px solid #171f46;
          background-color: #f2f3f7;
        }
      }
      .active {
        border: solid 1px #0055ff;
        &:hover {
          border: solid 1px #0055ff;
        }
        &:active {
          border: 1px solid #0055ff;
          background-color: #ffffff;
        }
      }
    }
  }
  .dialog-footer {
    width: 100%;
    height: 64px;
    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 64px;
      .footer-btn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 130px;
        height: 32px;
        .cancel-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #171f46;
          background-color: rgba(0, 11, 92, 0.03);
          border-radius: 2px;
          border: none;
          &:hover {
            color: #171f46;
            background-image: linear-gradient(
                rgba(0, 0, 0, 0.1),
                rgba(0, 0, 0, 0.1)
              ),
              linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
            background-blend-mode: normal, normal;
          }
          &:focus {
            color: #171f46;
            background-image: linear-gradient(
                rgba(0, 0, 0, 0.1),
                rgba(0, 0, 0, 0.1)
              ),
              linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
            background-blend-mode: normal, normal;
          }
          &:active {
            color: #171f46;
            background-image: linear-gradient(
                rgba(0, 0, 0, 0.2),
                rgba(0, 0, 0, 0.2)
              ),
              linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
            background-blend-mode: normal, normal;
          }
        }
        .confirm-btn {
          height: 32px;
          width: 60px;
          padding: 0;
          font-size: 14px;
          color: #ffffff;
          background-color: #0055ff;
          border-radius: 2px;
          border: none;
          &:hover {
            color: #ffffff;
            background-image: linear-gradient(
                rgba(0, 0, 0, 0.1),
                rgba(0, 0, 0, 0.1)
              ),
              linear-gradient(#0055ff, #0055ff);
            background-blend-mode: normal, normal;
          }
          &:focus {
            color: #ffffff;
            background-image: linear-gradient(
                rgba(0, 0, 0, 0.1),
                rgba(0, 0, 0, 0.1)
              ),
              linear-gradient(#0055ff, #0055ff);
            background-blend-mode: normal, normal;
          }
          &:active {
            color: #ffffff;
            background-image: linear-gradient(
                rgba(0, 0, 0, 0.2),
                rgba(0, 0, 0, 0.2)
              ),
              linear-gradient(#0055ff, #0055ff);
            background-blend-mode: normal, normal;
          }
        }
      }
    }
  }
  .el-dialog {
    min-height: 452px;
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border-radius: 2px;
    border: solid 1px #f7f7fa;
    .el-dialog__header {
      padding: 0;
      .el-dialog__title {
        color: #ffffff;
      }
    }
    .el-dialog__body {
      padding: 0;
      height: 100%;
    }
    .el-dialog__footer {
      padding: 0;
    }
  }
}
.chart-text-input {
  /deep/.el-input .el-input__inner {
    border: solid 1px #e64c62;
    &::-webkit-input-placeholder {
      color: #e64c62;
      font-weight: 400 !important;
    }
    &::-moz-placeholder {
      color: #e64c62;
      font-weight: 400 !important;
    }
    &::-ms-input-placeholder {
      color: #e64c62;
      font-weight: 400 !important;
    }
    &:hover {
      border-radius: 2px;
      border: solid 1px #e64c62;
    }
    &:focus {
      border-radius: 2px;
      border: solid 1px #e64c62;
    }
  }
}
/deep/.el-input .el-input__inner {
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  padding-left: 72px;
  border-radius: 2px;
  border: solid 1px #e5e6ee;
  font-weight: 500;
  &::-webkit-input-placeholder {
    color: #d1d2da;
    font-weight: 400 !important;
  }
  &::-moz-placeholder {
    color: #d1d2da;
    font-weight: 400 !important;
  }
  &::-ms-input-placeholder {
    color: #d1d2da;
    font-weight: 400 !important;
  }
  &:hover {
    border-radius: 2px;
    border: solid 1px #999ebe;
  }
  &:focus {
    border-radius: 2px;
    border: solid 1px #171f46;
  }
}
.el-input__inner {
  height: 32px;
  line-height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e6ee;
  &::-webkit-input-placeholder {
    color: #d1d2da;
    font-weight: 400 !important;
  }
  &::-moz-placeholder {
    color: #d1d2da;
    font-weight: 400 !important;
  }
  &::-ms-input-placeholder {
    color: #d1d2da;
    font-weight: 400 !important;
  }
  &:hover {
    border-radius: 2px;
    border: solid 1px #999ebe;
  }
  &:focus {
    border-radius: 2px;
    border: solid 1px #171f46;
  }
}
.el-range-editor.el-input__inner {
  padding: 0 10px;
}
.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 254px;
  /deep/.el-date-editor .el-range-input {
    font-weight: 500;
  }
}
/deep/.filter-conflicts-dialog {
  .dialog-input {
    width: 352px;
    height: 40px;
    padding-left: 16px;
    border-radius: 2px;
    border: solid 1px #e5e6ee;
    color: #171f46;
    outline: none;
    &:hover {
      border: solid 1px #999ebe;
    }

    &:focus {
      border: solid 1px #171f46;
    }
  }
  .el-dialog {
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border-radius: 2px;
    border: solid 1px #f7f7fa;
    .el-dialog__header {
      padding: 24px 24px 14px;
      .el-dialog__title {
        font-size: 16px;
      }
    }
    .el-dialog__body {
      max-height: 300px;
      overflow: auto;
      padding: 9px 24px 41px;
    }
    .el-dialog__footer {
      padding: 0 24px 24px;
    }
  }
}
.dialog-content {
  font-size: 14px;
  color: #747990;
}
.dialog-footer {
  justify-content: space-between;
  .cancel-btn {
    width: 60px;
    color: #171f46;
    background-color: rgba(0, 11, 92, 0.03);
    &:hover {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
        linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
        linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #171f46;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
        linear-gradient(rgba(0, 11, 92, 0.03), rgba(0, 11, 92, 0.03));
      background-blend-mode: normal, normal;
    }
  }
  .btn {
    height: 32px;
    padding: 0;
    border-radius: 2px;
    border: none;
    font-size: 14px;
  }
  .confirm-btn {
    width: 60px;
    color: #ffffff;
    background-color: #0055ff;
    &:hover {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
        linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:focus {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)),
        linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
    &:active {
      color: #ffffff;
      background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
        linear-gradient(#0055ff, #0055ff);
      background-blend-mode: normal, normal;
    }
  }
}
</style>

